import { Icon } from '@iconify/react'
import { Button } from '../../../components/ui/legacy'
import DeleteAccountModal from './ConfirmDeleteAccount'
import { useState } from 'react'
import { showErrorToast } from '../../../utils/showToast'
function DeleteConfirm({ uuid }) {
  const [openModal, setOpenModal] = useState(false)
  // HANDLE TẠI ĐÂY LUÔN cho gọn nè
  return (
    <>
      <div className="flex items-center justify-end">
        <Button
          onClickHandler={() => setOpenModal(!openModal)}
          variant={'super'}
        >
          <Icon
            icon="ph:trash-bold"
            width="24"
            height="24"
            style={{ color: 'white' }}
          />
          Xóa tài khoản
        </Button>
      </div>
      {openModal && (
        <DeleteAccountModal
          onCancel={() => setOpenModal(!openModal)}
          onAccept={() => {
            showErrorToast({ message: 'Sẽ được cập nhật trong phiên bản tới' })
          }}
        />
      )}
    </>
  )
}
export default DeleteConfirm
